import { set } from '@/utils/vuex'

export default {
	setUser: set('user'),
	setToken: set('token'),
	setCheckingToken: set('checkingToken'),
};
